export default __webpack_public_path__ + "static/media/results_icon.d4703577.svg";